import { Reducer } from 'redux';
import { TerminalsTypes, TerminalsState } from './types';

const INITIAL_STATE: TerminalsState = {
  terminalData: {
    id: '',
    name: '',
    phone: '',
    cnpj: '',
    elevators: false,
    escalators: false,
    stairs: false,
    accessRamps: false,
    tactileFloor: false,
    publicToilets: false,
    suggestionBox: false,
    sink: false,
    accessibleSink: false,
    integrationStation: false,
    wifi: false,
    foodCourt: false,
    bikeStation: false,
    bikeRack: false,
    Addresses: [],
    schedules: [],
    Blocks: [],
    bounds: [],
    createdAt: '',
    updatedAt: '',
    GarageQuantities: [],
    GarageServices: [],
    TransportSupervisor: {
      id: '',
      name: '',
      email: '',
    },
  },
  terminalList: [],
  terminalConfigList: [],
  terminalConfigData: {
    id: '',
    name: '',
    shortName: '',
    terminalIps: [],
  },
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<TerminalsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST TERMINALS
    case TerminalsTypes.LIST_TERMINALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalList: INITIAL_STATE.terminalList,
      };

    case TerminalsTypes.LIST_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalList: action.payload.terminalList,
        totalCount: action.payload.totalCount,
      };

    case TerminalsTypes.LIST_TERMINALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalList: INITIAL_STATE.terminalList,
      };

    // CASES GET TERMINAL
    case TerminalsTypes.GET_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalData: INITIAL_STATE.terminalData,
      };

    case TerminalsTypes.GET_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalData: action.payload.terminalData,
      };

    // CASES FILTER TERMINALS
    case TerminalsTypes.FILTER_TERMINALS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case TerminalsTypes.FILTER_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        totalCount: action.payload.totalCount,
        terminalList: action.payload.terminalList,
      };

    case TerminalsTypes.FILTER_TERMINALS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case TerminalsTypes.GET_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalData: INITIAL_STATE.terminalData,
      };

    // CASES CREATE TERMINAL
    case TerminalsTypes.CREATE_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalData: INITIAL_STATE.terminalData,
      };

    case TerminalsTypes.CREATE_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalData: action.payload.terminalData,
      };

    case TerminalsTypes.CREATE_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalData: INITIAL_STATE.terminalData,
      };

    // CASES UPDATE TERMINAL
    case TerminalsTypes.UPDATE_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case TerminalsTypes.UPDATE_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case TerminalsTypes.UPDATE_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE TERMINAL
    case TerminalsTypes.DELETE_TERMINAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case TerminalsTypes.DELETE_TERMINAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case TerminalsTypes.DELETE_TERMINAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST TERMINAL CONFIG
    case TerminalsTypes.LIST_TERMINAL_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalConfigList: INITIAL_STATE.terminalConfigList,
      };

    case TerminalsTypes.LIST_TERMINAL_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalConfigList: action.payload.terminalConfigList,
        totalCount: action.payload.totalCount,
      };

    case TerminalsTypes.LIST_TERMINAL_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalConfigList: INITIAL_STATE.terminalConfigList,
      };

    // CASES UPDATE_TERMINAL_CONFIG
    case TerminalsTypes.UPDATE_TERMINAL_CONFIG_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        terminalConfigData: INITIAL_STATE.terminalConfigData,
      };
    case TerminalsTypes.UPDATE_TERMINAL_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        terminalConfigData: action.payload.terminalConfigData,
      };
    case TerminalsTypes.UPDATE_TERMINAL_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        terminalConfigData: INITIAL_STATE.terminalConfigData,
      };

    default:
      return state;
  }
};

export default reducer;
